var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVictoryOneStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 250,
    viewBox: "0 0 371 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.704 173.395C185.303 175.681 180.844 186.541 177.415 193.971C176.272 193.971 156.267 193.971 154.553 200.83C153.094 206.665 164.841 217.405 170.556 221.978C168.842 226.55 165.412 240.839 168.842 244.269C172.788 248.215 185.798 240.458 192.276 235.695C199.134 240.839 211.137 247.698 215.71 244.269C219.71 241.268 216.472 228.455 214.566 221.978C223.711 214.662 230.57 205.402 229.999 201.402C229.155 195.5 214.566 193.971 207.136 193.4C203.707 185.398 197.648 172.938 191.704 173.395Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.327 194.819C97.361 197.446 96.1525 205.571 95.0682 211.194C94.2916 211.385 80.7006 214.739 80.6854 219.686C80.6724 223.895 90.4535 229.223 95.1031 231.371C94.7047 234.765 94.77 245.048 97.6748 246.803C101.018 248.822 108.556 241.371 112.158 237.05C117.68 239.395 126.985 242.042 129.516 238.946C131.732 236.237 127.383 228.075 125.003 223.994C129.99 217.49 133.097 210.05 132.038 207.427C130.476 203.559 120.308 204.966 115.165 205.823C111.493 200.962 105.289 193.512 101.327 194.819Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.538 238.12C129.538 238.12 129.006 242.013 126.721 242.326C124.435 242.638 113.823 240.958 113.27 240.843C112.718 240.718 105.193 247.25 101.301 248.054C97.4183 248.857 96.3018 245.559 96.3018 245.559L95.4673 239.517C105.423 237.201 116.379 235.405 127.889 234.111H127.899L129.538 238.12Z",
    fill: "#6E1A46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.312 224.765C124.312 224.765 127.187 229.138 128.695 233.29C129.623 235.844 130.03 238.308 128.932 239.623C126.052 243.079 111.978 237.535 111.978 237.535C111.978 237.535 102.22 249.092 98.0451 247.415C93.8715 245.744 95.0624 232.146 95.0624 232.146C95.0624 232.146 80.789 224.938 81.0881 220.45C81.1237 219.948 81.322 219.449 81.6578 218.971C82.6517 217.509 84.8193 216.155 87.1199 215.035C87.544 214.829 87.9715 214.632 88.3968 214.446C88.406 214.444 88.4197 214.435 88.4346 214.431C91.799 212.938 95.0544 211.991 95.0544 211.991C95.0544 211.991 95.8534 206.251 97.5086 201.636C98.515 198.815 99.8424 196.411 101.498 195.993C102.872 195.647 104.692 196.612 106.544 198.094C110.576 201.327 114.758 207.019 114.758 207.019C114.758 207.019 116.269 206.696 118.384 206.398C119.734 206.204 121.328 206.027 122.938 205.945C126.432 205.777 129.963 206.09 131.066 207.84C133.457 211.649 124.312 224.765 124.312 224.765Z",
    fill: "url(#paint0_radial_336_2444)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.539 222.556C120.539 222.556 126.062 230.957 123.94 233.498C121.819 236.044 111.453 231.96 111.453 231.96C111.453 231.96 104.266 240.472 101.192 239.238C98.1177 238.007 98.9946 227.992 98.9946 227.992C98.9946 227.992 88.4821 222.683 88.7021 219.378C88.7285 219.009 88.8752 218.64 89.1217 218.288C89.9894 217.016 92.0619 215.852 94.0851 214.956C94.0919 214.954 94.1023 214.948 94.1137 214.945C96.592 213.844 98.99 213.147 98.99 213.147C98.99 213.147 99.5792 208.92 100.798 205.521C101.539 203.443 102.516 201.672 103.736 201.365C104.748 201.109 106.089 201.821 107.453 202.912C110.423 205.293 113.503 209.486 113.503 209.486C113.503 209.486 114.616 209.248 116.174 209.029C117.168 208.885 118.343 208.756 119.528 208.695C122.101 208.57 124.702 208.802 125.514 210.09C127.274 212.895 120.539 222.556 120.539 222.556Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.312 224.764C124.312 224.764 131.811 236.17 128.931 239.621C126.051 243.077 111.977 237.533 111.977 237.533C111.977 237.533 102.219 249.091 98.0441 247.414C96.9941 246.992 96.2846 245.819 95.8112 244.294C94.3955 239.762 95.0615 232.144 95.0615 232.144C95.0615 232.144 83.8749 226.494 81.5148 222.081C81.2087 221.514 81.0551 220.966 81.0872 220.449C81.1227 219.947 81.321 219.447 81.6569 218.969C81.6363 219.199 81.6236 219.439 81.6225 219.685C81.6236 220.125 81.8667 220.797 82.3699 221.587C83.5574 223.467 86.2065 226.015 90.5062 227.671C93.796 228.937 98.0028 229.683 98.0028 229.683C98.0028 229.683 94.2281 238.71 96.4279 243.75C96.7156 244.412 97.1053 245.004 97.6234 245.497C102.737 250.395 109.912 236.863 111.022 234.66C111.125 234.467 111.177 234.359 111.177 234.359C111.177 234.359 117.88 241.968 126.564 239.274C134.659 236.76 120.45 223.6 120.612 223.538C121.331 223.273 128.284 217.499 130.099 210.382C130.214 209.928 130.263 209.518 130.244 209.151C130.139 206.573 127.021 205.888 122.938 205.944C126.432 205.775 129.963 206.088 131.066 207.838C131.18 208.02 131.268 208.222 131.333 208.441C132.606 212.864 124.312 224.764 124.312 224.764Z",
    fill: "#E07090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M97.5077 201.637C96.554 207.221 97.4882 212.566 97.4882 212.566C97.4882 212.566 95.5178 212.628 93.3032 213.031C91.3201 213.395 88.9037 214.262 88.4326 214.433C91.7969 212.939 95.0524 211.992 95.0524 211.992C95.0524 211.992 95.8536 206.252 97.5077 201.637Z",
    fill: "#E07090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.384 206.398C114.344 207.706 113.203 208.937 113.203 208.937C113.203 208.937 112.83 207.46 111.579 205.04C110.65 203.247 107.939 199.813 106.542 198.096C110.574 201.328 114.756 207.021 114.756 207.021C114.756 207.021 116.269 206.696 118.384 206.398Z",
    fill: "#E07090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.333 208.444C132.606 212.864 124.312 224.766 124.312 224.766C122.387 223.424 120.613 223.541 120.613 223.541C121.332 223.276 128.285 217.502 130.1 210.385C130.216 209.931 130.264 209.521 130.245 209.154C130.646 208.874 131.015 208.635 131.333 208.444Z",
    fill: "url(#paint1_linear_336_2444)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.977 237.535C111.977 237.535 102.219 249.093 98.044 247.416C96.994 246.994 96.2844 245.821 95.811 244.295C96.0082 244.12 96.2134 243.937 96.4289 243.752C96.7166 244.414 97.1063 245.006 97.6245 245.499C102.738 250.397 109.913 236.865 111.023 234.662C110.996 235.015 111.153 235.804 111.977 237.535Z",
    fill: "url(#paint2_linear_336_2444)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.0042 229.685C98.0042 229.685 95.9375 230.631 95.0628 232.146C95.0628 232.146 83.8763 226.496 81.5161 222.083L82.3712 221.589C83.5588 223.469 86.2078 226.017 90.5075 227.673C93.7962 228.939 98.0042 229.685 98.0042 229.685Z",
    fill: "url(#paint3_linear_336_2444)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.312 224.765C124.312 224.765 127.187 229.138 128.696 233.29C114.082 218.791 98.9876 215.059 87.1201 215.035C87.5442 214.829 87.9718 214.632 88.3971 214.446C88.4062 214.444 88.42 214.435 88.4349 214.431C91.7992 212.938 95.0547 211.991 95.0547 211.991C95.0547 211.991 95.8536 206.251 97.5089 201.636C98.5153 198.815 99.8427 196.411 101.498 195.993C102.872 195.647 104.693 196.612 106.544 198.094C110.576 201.327 114.758 207.019 114.758 207.019C114.758 207.019 116.269 206.696 118.384 206.398C119.734 206.204 121.329 206.027 122.938 205.945C126.432 205.777 129.963 206.09 131.066 207.84C133.457 211.649 124.312 224.765 124.312 224.765Z",
    fill: "url(#paint4_radial_336_2444)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.4803 229.714C96.3773 231.188 95.8534 244.241 100.055 244.797C104.256 245.353 111.246 234.639 110.195 232.895C109.142 231.151 101.195 228.899 99.4803 229.714Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.295 196.775C98.9369 197.675 98.7042 203.396 101.924 207.619C105.144 211.843 113.214 211.756 113.052 209.382C112.889 207.007 106.243 194.886 101.295 196.775Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.046 198.03C102.129 197.995 102.186 203.419 105.005 206.404C107.825 209.389 112.565 209.183 112.322 207.876C112.08 206.569 107.701 198.097 104.046 198.03Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6919 220.228C82.2781 220.633 83.1435 218.025 86.8173 216.16C92.3974 213.326 98.6813 213.225 98.1139 213.746C97.5477 214.267 87.8765 215.165 82.6919 220.228Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.942 209.418C113.942 209.418 116.9 207.733 120.605 206.929C124.31 206.125 128.143 207.385 127.733 207.488C127.322 207.592 124.574 206.823 113.942 209.418Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9077 232.222C97.9077 232.222 96.5814 235.876 96.7293 238.106C96.8771 240.335 98.2091 243.798 98.3421 243.372C98.4739 242.946 96.8554 241.029 97.9077 232.222Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M282.418 194.525C277.685 195.005 272.836 201.636 269.261 206.109C268.484 205.917 254.893 202.564 252.579 206.937C250.61 210.656 256.79 219.922 259.907 223.987C257.975 226.806 253.251 235.939 255.006 238.844C257.025 242.187 267.164 239.097 272.364 236.947C276.161 241.591 283.166 248.263 286.847 246.699C290.069 245.331 290.016 236.084 289.807 231.364C297.246 227.926 303.458 222.785 303.74 219.971C304.157 215.82 294.501 212.336 289.549 210.702C288.56 204.691 286.533 195.21 282.418 194.525Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.992 83.3824C235.992 83.3824 218.611 142.213 171.996 144.889C126.452 147.519 120.268 91.1124 120.009 88.5164C120 88.4594 120 88.4244 120 88.4244L120.083 88.4124L125.714 87.8494C125.714 87.8494 126.628 102.896 133.477 116.92C139.735 129.727 150.941 141.684 170.916 140.489C189.174 139.398 201.626 128.842 209.86 117.287C220.512 102.344 224.121 85.7354 224.121 85.7354L235.992 83.3824Z",
    fill: "url(#paint5_linear_336_2444)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M235.992 83.3824C235.992 83.3824 218.611 142.213 171.996 144.889C126.452 147.519 120.268 91.1124 120.009 88.5164L120.083 88.4134L125.714 87.8504C125.714 87.8504 126.628 102.897 133.477 116.921C132.388 117.633 131.889 119.482 134.012 123.985C138.424 133.3 148.781 147.462 179.759 142.615C203.648 138.882 210.377 124.215 209.86 117.289C220.512 102.346 224.121 85.7374 224.121 85.7374L235.992 83.3824Z",
    fill: "#89C2FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.665 85.1728C235.665 85.1728 235.665 85.6158 235.651 86.4248C235.467 96.0258 232.913 157.747 198.195 159.971C188.71 160.578 180.822 155.608 174.338 147.943C171.898 145.054 169.649 141.789 167.606 138.284C167.599 138.274 167.592 138.274 167.592 138.265C155.88 118.302 150.368 90.8938 149.226 84.6918C149.07 83.8638 148.999 83.4108 148.999 83.4108H157.632C157.632 83.4108 159.164 101.766 164.627 120.006C169.876 137.591 178.779 155.07 193.457 155.956C215.427 157.285 224.72 137.36 228.607 118.446C232.026 101.824 231.274 85.9818 231.274 85.9818L232.182 85.8178L235.665 85.1728Z",
    fill: "url(#paint6_linear_336_2444)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.733 131.321C165.364 133.44 166.315 135.818 167.592 138.264C155.88 118.301 150.368 90.8928 149.226 84.6908L155.164 83.4098H157.633C157.633 83.4098 159.165 101.765 164.628 120.005C163.655 121.624 162.832 124.917 164.733 131.321Z",
    fill: "#89C2FE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M235.651 86.4248C235.467 96.0258 232.913 157.747 198.195 159.971C188.71 160.578 180.822 155.608 174.338 147.943C180.183 154.318 188.434 159.345 199.018 159.085C218.526 158.603 230.231 127.382 229.401 120.526C229.295 119.621 229.011 118.937 228.607 118.446C232.026 101.824 231.274 85.9818 231.274 85.9818L232.182 85.8178L235.651 86.4248Z",
    fill: "#89C2FE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2236 0.855042C25.2236 0.855042 20.2396 8.93288 19.1197 21.3058C17.9998 33.6788 22.8119 47.6565 22.8119 47.6565L25.2236 0.855042Z",
    fill: "#4ABAFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54855 40.4028C6.54855 40.4028 2.44602 53.4211 4.74316 65.3803C7.04146 77.3394 16.1704 83.0777 16.1704 83.0777L6.54855 40.4028Z",
    fill: "#4ABAFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0469724 77.7026C0.0469724 77.7026 -0.677477 92.9539 15.3487 106.034C31.3748 119.114 65.9615 112.515 66.2561 112.515C66.5507 112.515 76.0442 124.597 90.8071 124.417C201.655 123.07 276.114 125.522 280.564 125.168C285.013 124.814 306.397 112.929 306.592 112.906C310.758 112.42 341.209 117.997 355.276 107.154C369.343 96.3113 370.959 78.701 370.959 78.701L342.327 92.6238L359.816 79.0277C359.816 79.0277 364.659 74.2753 366.692 63.3306C368.724 52.3859 364.059 39.9029 364.059 39.9029L353.435 45.757L346.541 48.0552L350.609 39.1292C350.609 39.1292 352.373 34.8868 351.932 23.0434C351.49 11.2001 345.021 0.0043335 345.021 0.0043335C345.021 0.0043335 345.258 25.7681 337.902 35.2765C330.544 44.7849 322.985 70.3424 287.68 68.3834C252.374 66.4232 73.6829 89.499 56.4176 72.8435C39.1523 56.1869 40.0441 81.2389 40.0441 81.2389L28.1549 95.2063L0.0469724 77.7026Z",
    fill: "#4ABAFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8353 77.1835C77.0756 77.979 77.7656 78.4237 77.7656 78.4237C77.7656 78.4237 77.5111 81.372 75.2415 84.8292C73.4705 87.5332 70.4684 90.5559 65.3789 92.7201C66.5986 96.0925 68.3375 101.078 68.8785 105.161C69.2075 107.61 69.1124 109.732 68.2102 111.004C68.2102 111.004 66.132 111.344 62.6003 111.651C61.3165 111.768 59.8424 111.873 58.2101 111.958C51.3164 112.33 41.5695 112.33 31.2393 110.686C4.94818 106.496 -0.588354 79.0805 0.0478315 77.7016C0.207164 77.352 4.68225 77.956 11.1839 79.0267C2.39198 64.4758 5.45713 44.8022 6.54954 40.4005C6.60227 40.1781 6.74096 40.0085 6.94156 39.9019C8.46841 39.0536 13.9304 41.2166 21.2162 44.9076C21.1096 44.3242 21.0041 43.7407 20.9193 43.179C17.5997 22.6469 24.1117 0.279526 25.9778 0.00327265C26.1154 -0.0185067 26.222 0.0674644 26.2965 0.289843C31.2817 14.0555 53.0014 41.3656 70.6277 57.8789C71.084 58.3031 71.5287 58.7169 71.9746 59.1307C78.4866 65.081 84.351 69.4495 88.4765 70.9351C88.4765 70.9351 83.3022 74.2341 75.8353 77.1835Z",
    fill: "url(#paint7_linear_336_2444)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.378 92.7205C66.5977 96.0929 68.3366 101.078 68.8776 105.161C69.2066 107.611 69.1114 109.732 68.2093 111.005C68.2093 111.005 66.1311 111.344 62.5994 111.651C61.3156 111.768 59.8415 111.874 58.2092 111.959C55.9189 106.497 53.8613 99.9845 52.9913 93.6215C50.2872 73.9261 65.6864 61.0408 70.628 57.8805C71.3284 57.4346 71.7307 57.2019 71.7307 57.2019L71.9749 59.1323L75.2418 84.8296C73.4708 87.5348 70.4687 90.5575 65.378 92.7205Z",
    fill: "#BA36FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.824 64.0103C51.824 64.0103 29.3936 61.1675 21.216 44.9098C21.1312 44.4536 21.0464 43.9871 20.9719 43.5412C20.9501 43.4139 20.9398 43.297 20.9191 43.1801C17.5995 22.6479 24.1115 0.280587 25.9777 0.0043335C24.0152 8.21285 22.2763 34.7905 29.5518 45.1425C31.3973 47.7733 33.55 50.1701 35.7669 52.3228C35.799 52.3549 35.83 52.3755 35.862 52.4076C43.4562 59.7255 51.824 64.0103 51.824 64.0103Z",
    fill: "url(#paint8_linear_336_2444)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7003 87.0558C36.7003 87.0558 20.6329 89.2933 11.1829 79.0273C11.1829 79.0273 11.1829 79.0169 11.1726 79.0066C2.39096 64.4557 5.45611 44.8028 6.54852 40.4022C6.60124 40.1798 6.73995 40.0102 6.94055 39.9036C6.94055 39.9036 6.70671 45.1535 7.29016 51.708C7.29016 51.7825 7.30048 51.8455 7.30048 51.9097C7.86216 58.1145 9.14599 65.4209 12.0197 70.554C12.7728 71.9112 13.6429 73.1102 14.639 74.096C18.9444 78.3704 24.301 81.5628 28.6488 83.7052C28.6591 83.7052 28.6591 83.7052 28.6706 83.7155C28.6809 83.7155 28.6809 83.7155 28.6809 83.7155C33.2431 85.9634 36.7003 87.0558 36.7003 87.0558Z",
    fill: "url(#paint9_linear_336_2444)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2103 111.005C68.2103 111.005 50.7857 113.805 31.2393 110.687C30.1469 110.517 29.0866 110.295 28.0687 110.041C24.0487 109.055 20.5594 107.506 17.5585 105.596C2.9331 96.3482 -0.461039 78.8067 0.0479093 77.704C0.0479093 77.704 0.556859 79.3259 1.73409 81.7973C1.73409 81.7973 1.7444 81.8077 1.75472 81.8294C3.91775 86.4008 8.32978 93.8459 15.8918 99.3607C18.3517 101.164 21.1521 102.755 24.3124 103.974C25.2775 104.346 26.2633 104.685 27.2824 104.982C32.4578 106.499 38.2167 107.082 43.8381 107.157H43.8908C54.4538 107.306 64.4551 105.672 68.8774 105.163C69.2064 107.61 69.1113 109.732 68.2103 111.005Z",
    fill: "url(#paint10_linear_336_2444)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.8243 64.0102C51.8243 64.0102 29.3939 61.1674 21.2163 44.9097C21.0467 44.6552 20.9722 44.1669 20.9722 43.541C21.0249 40.2432 23.4011 33.095 25.1825 35.9263C27.3042 39.2883 26.4972 44.0924 35.7672 52.3227C35.7993 52.3548 35.8303 52.3754 35.8624 52.4075C43.4565 59.7254 51.8243 64.0102 51.8243 64.0102Z",
    fill: "url(#paint11_linear_336_2444)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.7002 87.0559C36.7002 87.0559 20.6328 89.2935 11.1829 79.0274C11.1829 79.0274 11.1829 79.0171 11.1726 79.0068C11.0132 78.5299 8.05469 69.6416 10.8012 70.1621C11.0453 70.2045 11.4591 70.342 12.0208 70.5541C12.7739 71.9113 13.644 73.1103 14.6401 74.0961C23.4641 82.8571 36.7002 87.0559 36.7002 87.0559Z",
    fill: "url(#paint12_linear_336_2444)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.2104 111.004C68.2104 111.004 50.7857 113.804 31.2394 110.686C30.147 110.517 29.0867 110.294 28.0688 110.04C24.0488 109.054 20.5595 107.505 17.5585 105.596C15.7761 103.803 11.9165 99.1159 14.7478 99.3279C14.9278 99.3383 15.321 99.3486 15.893 99.3601C18.3529 101.163 21.1533 102.754 24.3135 103.974C25.2787 104.345 26.2645 104.685 27.2836 104.981C42.2058 109.361 62.1018 105.947 68.8786 105.161C69.2065 107.61 69.1113 109.732 68.2104 111.004Z",
    fill: "url(#paint13_linear_336_2444)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3066 15.8944C24.3066 15.8944 24.4728 33.8646 31.6611 43.8808C38.8495 53.897 50.5816 63.3309 50.5816 63.3309C50.5816 63.3309 32.0543 53.1611 27.0852 40.5956C22.1161 28.0301 24.3066 15.8944 24.3066 15.8944Z",
    fill: "#FFC08C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6714 83.7154C28.6611 83.7051 28.6611 83.7051 28.6497 83.7051C24.3018 81.5627 18.9452 78.3703 14.6398 74.0958C13.6426 73.1089 12.7737 71.911 12.0206 70.5538C9.14684 65.4208 7.86301 58.1132 7.30134 51.9096C7.30134 51.8454 7.29102 51.7823 7.29102 51.7078C7.29102 51.7078 8.89122 63.0755 14.8989 71.3379C19.3361 77.4395 28.3963 83.5251 28.6714 83.7154Z",
    fill: "#FFC08C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8383 107.154C38.2169 107.079 32.458 106.496 27.2825 104.979C26.2647 104.682 25.2777 104.343 24.3125 103.972C21.1522 102.752 18.3519 101.161 15.892 99.358C8.32995 93.8432 3.91791 86.3981 1.75488 81.8268C2.11596 82.4847 8.05484 93.0684 19.0947 99.8669C29.3504 106.19 41.4941 107.038 43.8383 107.154Z",
    fill: "#FFC08C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.8679 20.4285C32.7935 17.9067 30.1525 40.4529 38.408 50.6972C46.6635 60.9415 65.3639 59.5316 65.3639 57.6998C65.3639 55.8692 38.4539 22.5503 35.8679 20.4285Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.9112 48.7787C13.3976 48.1425 15.5262 69.727 21.5625 74.9574C40.2056 91.1131 53.2434 68.9085 48.6239 66.7283C26.0216 56.0644 21.2083 49.0446 18.9112 48.7787Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.50285 80.5296C3.12361 80.1536 15.5172 98.0906 23.5308 101.418C31.5445 104.746 34.4182 104.987 36.399 104.572C38.3797 104.157 47.4847 91.4204 43.8383 91.0181C19.6415 88.345 9.15419 80.8242 6.50285 80.5296Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.5853 13.3176C27.054 10.8107 23.9304 25.584 31.1405 37.1259C34.4968 42.4996 49.8432 44.1698 49.3515 41.1069C48.8597 38.0441 33.8583 14.5751 31.5853 13.3176Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74139 41.8778C5.0091 42.4005 10.6855 58.8473 14.8098 62.9716C18.9341 67.0959 36.87 65.3639 35.0783 61.9697C33.2867 58.5745 11.6873 41.4651 8.74139 41.8778Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.755 47.1073C15.0653 46.9434 16.755 52.3664 18.3896 53.6262C20.0241 54.8848 26.1224 54.9742 24.7526 53.029C23.3828 51.0837 18.1248 47.2391 16.755 47.1073Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.2046 19.7533C32.7114 18.5405 33.8565 27.7956 35.2046 30.7564C36.5526 33.7173 45.8592 36.8891 45.6999 34.2916C45.5394 31.6941 37.6576 20.9466 35.2046 19.7533Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M295.163 77.1833C293.923 77.9788 293.233 78.4235 293.233 78.4235C293.233 78.4235 293.487 81.3718 295.757 84.829C297.528 87.5331 300.53 90.5558 305.621 92.7199C304.401 96.0923 302.662 101.077 302.121 105.161C301.792 107.61 301.887 109.732 302.79 111.004C302.79 111.004 304.868 111.344 308.399 111.651C309.683 111.768 311.157 111.873 312.791 111.958C319.685 112.329 329.431 112.329 339.76 110.686C366.052 106.496 371.588 79.0804 370.952 77.7014C370.793 77.3518 366.318 77.9559 359.816 79.0265C368.608 64.4756 365.543 44.802 364.45 40.4003C364.397 40.1779 364.259 40.0083 364.058 39.9017C362.531 39.0534 357.069 41.2164 349.784 44.9074C349.889 44.324 349.996 43.7405 350.08 43.1789C353.4 22.6467 346.888 0.279343 345.022 0.00308955C344.884 -0.0186898 344.778 0.0672812 344.704 0.28966C339.719 14.0553 318 41.3655 300.373 57.8788C299.917 58.3029 299.472 58.7167 299.026 59.1305C292.514 65.0809 286.65 69.4493 282.524 70.9349C282.522 70.9361 287.698 74.2339 295.163 77.1833Z",
    fill: "url(#paint14_linear_336_2444)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M305.621 92.7203C304.401 96.0927 302.663 101.078 302.121 105.161C301.792 107.611 301.888 109.732 302.79 111.005C302.79 111.005 304.868 111.344 308.4 111.651C309.683 111.768 311.158 111.874 312.791 111.958C315.081 106.496 317.139 99.9843 318.009 93.6213C320.713 73.926 305.314 61.0406 300.371 57.8803C299.671 57.4344 299.268 57.2017 299.268 57.2017L299.024 59.1321L295.757 84.8294C297.529 87.5346 300.53 90.5573 305.621 92.7203Z",
    fill: "#BA36FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M319.176 64.0101C319.176 64.0101 341.606 61.1674 349.784 44.9097C349.869 44.4534 349.953 43.9869 350.028 43.541C350.049 43.4138 350.06 43.2968 350.081 43.1799C353.4 22.6478 346.888 0.280404 345.022 0.00415039C346.985 8.21266 348.723 34.7903 341.448 45.1424C339.603 47.7731 337.45 50.17 335.233 52.3227C335.201 52.3548 335.169 52.3754 335.138 52.4075C327.544 59.7253 319.176 64.0101 319.176 64.0101Z",
    fill: "url(#paint15_linear_336_2444)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M334.298 87.0556C334.298 87.0556 350.366 89.2932 359.816 79.0271C359.816 79.0271 359.816 79.0168 359.826 79.0064C368.608 64.4556 365.542 44.8026 364.45 40.402C364.397 40.1796 364.259 40.01 364.058 39.9034C364.058 39.9034 364.292 45.1533 363.708 51.7078C363.708 51.7823 363.698 51.8453 363.698 51.9095C363.136 58.1143 361.853 65.4207 358.979 70.5538C358.226 71.911 357.356 73.11 356.36 74.0958C352.054 78.3703 346.698 81.5626 342.35 83.705C342.339 83.705 342.339 83.705 342.329 83.7154C342.319 83.7154 342.319 83.7154 342.319 83.7154C337.755 85.9632 334.298 87.0556 334.298 87.0556Z",
    fill: "url(#paint16_linear_336_2444)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M302.79 111.004C302.79 111.004 320.214 113.805 339.761 110.687C340.853 110.517 341.913 110.295 342.931 110.04C346.951 109.055 350.44 107.506 353.441 105.596C368.067 96.348 371.461 78.8065 370.952 77.7038C370.952 77.7038 370.443 79.3258 369.266 81.7971C369.266 81.7971 369.256 81.8075 369.245 81.8293C367.082 86.4006 362.67 93.8457 355.108 99.3605C352.648 101.164 349.848 102.755 346.688 103.974C345.722 104.346 344.737 104.685 343.718 104.982C338.542 106.498 332.783 107.082 327.162 107.156H327.109C316.546 107.305 306.545 105.672 302.123 105.163C301.792 107.61 301.888 109.732 302.79 111.004Z",
    fill: "url(#paint17_linear_336_2444)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.176 64.01C319.176 64.01 341.606 61.1672 349.784 44.9095C349.953 44.655 350.028 44.1667 350.028 43.5409C349.975 40.243 347.599 33.0948 345.818 35.9261C343.697 39.2882 344.503 44.0922 335.233 52.3225C335.201 52.3546 335.169 52.3752 335.138 52.4073C327.544 59.7252 319.176 64.01 319.176 64.01Z",
    fill: "url(#paint18_linear_336_2444)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.298 87.0558C334.298 87.0558 350.366 89.2933 359.816 79.0272C359.816 79.0272 359.816 79.0169 359.826 79.0066C359.985 78.5297 362.944 69.6415 360.197 70.1619C359.953 70.2043 359.539 70.3419 358.978 70.5539C358.225 71.9111 357.355 73.1101 356.358 74.0959C347.534 82.8569 334.298 87.0558 334.298 87.0558Z",
    fill: "url(#paint19_linear_336_2444)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.789 111.004C302.789 111.004 320.214 113.804 339.76 110.686C340.853 110.517 341.913 110.294 342.931 110.04C346.951 109.054 350.44 107.505 353.441 105.596C355.223 103.803 359.083 99.1157 356.252 99.3278C356.072 99.3381 355.679 99.3484 355.107 99.3599C352.647 101.163 349.847 102.754 346.686 103.974C345.721 104.345 344.735 104.684 343.716 104.981C328.794 109.361 308.898 105.946 302.121 105.161C301.792 107.61 301.887 109.731 302.789 111.004Z",
    fill: "url(#paint20_linear_336_2444)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M346.692 15.8942C346.692 15.8942 346.526 33.8644 339.338 43.8806C332.149 53.8968 320.417 63.3307 320.417 63.3307C320.417 63.3307 338.944 53.1609 343.913 40.5954C348.883 28.0322 346.692 15.8942 346.692 15.8942Z",
    fill: "#FFC08C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M342.327 83.7152C342.337 83.7049 342.337 83.7049 342.348 83.7049C346.696 81.5625 352.052 78.3701 356.358 74.0956C357.355 73.1087 358.224 71.9108 358.977 70.5536C361.851 65.4206 363.134 58.113 363.696 51.9094C363.696 51.8452 363.706 51.7821 363.706 51.7076C363.706 51.7076 362.106 63.0753 356.099 71.3377C351.664 77.4393 342.603 83.5249 342.327 83.7152Z",
    fill: "#FFC08C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M327.161 107.154C332.782 107.079 338.541 106.496 343.716 104.979C344.734 104.682 345.721 104.343 346.686 103.972C349.847 102.752 352.647 101.161 355.107 99.3578C362.669 93.8431 367.081 86.398 369.244 81.8266C368.883 82.4846 362.944 93.0682 351.904 99.8668C341.648 106.19 329.505 107.038 327.161 107.154Z",
    fill: "#FFC08C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.132 20.4283C338.206 17.9065 340.847 40.4527 332.592 50.697C324.336 60.9413 305.636 59.5314 305.636 57.6996C305.636 55.869 332.546 22.5501 335.132 20.4283Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.089 48.7785C357.602 48.1423 355.473 69.7268 349.437 74.9572C330.794 91.1129 317.756 68.9083 322.376 66.7281C344.977 56.0642 349.79 49.0444 352.089 48.7785Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.497 80.5294C367.876 80.1534 355.482 98.0904 347.469 101.418C339.455 104.746 336.582 104.986 334.601 104.571C332.62 104.157 323.515 91.4202 327.16 91.0178C351.357 88.3447 361.845 80.824 364.497 80.5294Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.414 13.3175C343.946 10.8106 347.069 25.5838 339.859 37.1257C336.503 42.4995 321.157 44.1696 321.648 41.1067C322.14 38.0439 337.14 14.5749 339.414 13.3175Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.257 41.8776C365.99 42.4003 360.313 58.8471 356.189 62.9714C352.065 67.0957 334.129 65.3637 335.92 61.9696C337.712 58.5743 359.311 41.4649 362.257 41.8776Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.245 47.1071C355.934 46.9432 354.245 52.3662 352.61 53.626C350.976 54.8858 344.877 54.974 346.247 53.0288C347.616 51.0836 352.875 47.2389 354.245 47.1071Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M335.794 19.7531C338.287 18.5404 337.142 27.7954 335.794 30.7563C334.446 33.7171 325.14 36.8889 325.299 34.2914C325.459 31.6939 333.342 20.9464 335.794 19.7531Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M313.885 78.0168V84.6847C313.885 105.805 296.616 123.075 275.516 123.075H94.0404C72.9408 123.075 55.6606 105.805 55.6606 84.6847V78.0168C55.6606 71.2022 59.417 65.2026 66.023 60.0374C70.176 56.782 75.4672 53.8498 81.6755 51.2409C81.6961 51.2306 81.7167 51.2202 81.7488 51.2099C81.8325 51.179 81.9678 51.1263 82.1661 51.0529C89.2306 48.1207 97.4322 45.6058 106.47 43.5184C116.425 41.2018 127.381 39.4067 138.891 38.1125H138.901C145.131 37.403 151.517 36.8608 158.007 36.4538C171.656 35.5987 185.723 35.4108 199.57 35.8693C199.685 35.8796 199.81 35.8899 199.926 35.8899H199.936C202.608 35.9839 205.258 36.0985 207.908 36.2441C213.981 36.5673 219.982 37.0167 225.847 37.6001C237.899 38.79 249.408 40.522 259.906 42.7974C269.788 44.9363 278.762 47.5453 286.432 50.6448C286.735 50.7594 287.027 50.8741 287.277 50.9784C287.861 51.218 288.435 51.4587 288.999 51.7086C293.121 53.5036 296.825 55.4443 300.04 57.542C308.794 63.2504 313.885 70.0754 313.885 78.0168Z",
    fill: "url(#paint21_linear_336_2444)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.702 116.727C190.788 116.669 244.991 94.5913 260.281 92.6231C275.571 90.655 296.163 102.409 292.539 107.006C288.916 111.602 270.974 117.876 194.702 116.727Z",
    fill: "#B2ABFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.2577 62.1515C59.6028 67.9528 71.8531 103.498 134.25 111.837C196.646 120.175 312.602 77.5758 295.279 60.7839C277.957 43.9909 116.877 24.5477 67.2577 62.1515Z",
    fill: "#C4BAFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.0518 62.6648C60.5751 67.799 96.4571 84.8063 142.339 83.4594C188.221 82.1126 229.349 45.874 218.153 43.4302C206.959 40.9863 114.976 34.8514 69.0518 62.6648Z",
    fill: "#C4BAFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M313.886 78.0183V84.6897C313.886 86.1432 313.801 87.5852 313.642 88.9951C311.669 106.462 297.861 120.473 280.488 122.753C278.865 122.965 277.2 123.071 275.514 123.071H94.0407C93.0331 123.071 92.0359 123.028 91.0501 122.954C91.0398 122.954 91.0398 122.954 91.0398 122.943C71.3238 121.405 55.6587 104.797 55.6587 84.6885V78.0172C55.6587 77.2859 55.7011 76.5637 55.7859 75.853C56.4966 69.9244 60.1235 64.6539 66.0199 60.0401C63.9623 62.4576 61.6606 67.9941 60.7172 74.7927C58.5645 90.3409 63.4637 112.496 94.4225 119.178C95.1114 119.327 102.748 119.443 114.584 119.527C155.384 119.792 246.095 119.623 273.69 118.722C278.177 118.584 280.998 118.414 281.666 118.233C306.822 111.307 310.344 90.6377 307.671 75.2271C307.671 75.2065 307.671 75.1951 307.671 75.1951C306.229 66.8914 302.984 60.1249 300.373 57.8759C300.236 57.759 300.129 57.6535 300.034 57.5366C308.795 63.2543 313.886 70.0746 313.886 78.0183Z",
    fill: "url(#paint22_linear_336_2444)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 118.234C275.685 119.878 97.8806 119.92 94.4223 119.177C63.4647 112.496 58.5644 90.3405 60.7171 74.7924H60.7274C60.7274 74.7924 56.6547 112.485 95.3657 116.642C122.58 119.558 273.35 118.732 288.623 112.155C307.893 103.862 307.681 76.2974 307.671 75.2268C310.344 90.6385 306.822 111.308 281.666 118.234Z",
    fill: "#676687"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M280.489 122.753C278.866 122.965 277.201 123.07 275.515 123.07H94.0405C93.0329 123.07 92.0357 123.028 91.0499 122.954C91.0396 122.954 91.0396 122.954 91.0396 122.943C90.0526 122.105 92.1526 120.525 98.5477 119.995C99.6825 119.9 105.569 119.73 114.583 119.528C155.383 119.793 246.093 119.624 273.689 118.723C277.592 118.956 279.914 119.264 280.254 119.645C281.305 120.843 281.242 121.883 280.489 122.753Z",
    fill: "#6E1A46"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M286.427 50.6439C277.508 47.2291 246.758 37.4502 182.534 38.3305C113.776 39.2728 86.076 49.5515 82.1626 51.0474C131.383 30.6207 236.485 30.4934 286.427 50.6439Z",
    fill: "#F194FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.316 50.3545C98.0471 52.0728 123.309 65.5565 136.41 63.8474C149.512 62.1383 174.663 42.8808 168.306 42.1644C161.95 41.4479 122.231 42.3409 102.316 50.3545Z",
    fill: "#C4BAFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M306.963 88.7203C305.657 88.381 297.224 103.072 302.394 103.116C307.565 103.16 310.737 89.7027 306.963 88.7203Z",
    fill: "#290C63"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M301.818 96.7941C302.422 96.4594 303.367 98.1089 304.088 97.859C304.811 97.6079 307.668 94.3972 307.992 95.3991C308.316 96.4009 305.104 103.957 302.321 102.955C299.537 101.954 301.645 96.8904 301.818 96.7941Z",
    fill: "#676687"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7661 67.1399C81.7661 67.1399 86.8086 66.6905 89.8038 65.7918C92.7991 64.8932 94.2973 60.5568 94.2973 60.5568C94.2973 60.5568 92.7498 63.8947 81.7661 67.1399Z",
    fill: "#5A13A1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8916 65.3608C93.8916 65.3608 96.0443 65.848 97.9357 65.6978C99.827 65.5477 100.482 64.7613 100.482 64.7613C100.482 64.7613 94.3971 65.417 93.8916 65.3608Z",
    fill: "#5A13A1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7661 67.1399C81.7661 67.1399 87.0585 64.9872 89.7167 63.4145C92.3749 61.8418 94.2973 60.5579 94.2973 60.5579C94.2973 60.5579 91.9577 65.0617 81.7661 67.1399Z",
    fill: "#C669D6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8916 65.3604C93.8916 65.3604 95.9251 65.365 97.8061 65.1598C99.6883 64.9558 100.482 64.7609 100.482 64.7609C100.482 64.7609 96.5877 64.7151 93.8916 65.3604Z",
    fill: "#C669D6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7716 71.7939C10.455 72.2788 17.3865 79.1405 17.9058 76.9969C18.4251 74.8534 14.6813 71.3939 12.7716 71.7939Z",
    fill: "#7A1032"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0565 75.0017C13.9384 74.7255 15.2177 75.2883 15.7232 74.8768C16.2287 74.4653 15.8516 73.029 16.5026 73.5413C17.1537 74.0537 18.433 76.7349 17.6925 77.3287C16.952 77.9224 14.4565 75.9382 14.0565 75.0017Z",
    fill: "#FCF800"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.312 54.5362C309.526 55.42 303.978 62.2977 309.669 62.3469C315.361 62.3962 320.653 53.3647 314.312 54.5362Z",
    fill: "#E1ABFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.14 49.0671C327.179 49.7205 326.644 53.5101 329.091 52.1621C331.536 50.814 331.985 48.118 329.14 49.0671Z",
    fill: "#E1ABFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.6587 101.587C51.5825 99.6069 43.3247 102.219 47.9179 104.724C52.511 107.229 61.0038 104.183 55.6587 101.587Z",
    fill: "#E1ABFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8618 1.74054C26.8618 1.74054 29.9132 12.7724 35.9083 20.7849C41.9022 28.7974 49.8321 35.628 49.8321 35.628C49.8321 35.628 34.8869 19.9148 26.8618 1.74054Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M319.704 37.3663C319.498 37.5956 327.068 31.1202 332.685 23.3312C338.302 15.5434 342.327 5.58569 342.327 5.58569C342.327 5.58569 330.491 25.3567 319.704 37.3663Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.4596 92.6755C66.7922 93.4664 74.0653 106.118 76.7981 103.384C79.5319 100.651 73.8785 91.3653 69.4596 92.6755Z",
    fill: "#ABAAD4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.5808 96.4948C78.271 96.5315 78.8591 103.871 81.4795 101.775C84.0999 99.678 82.9398 96.4569 80.5808 96.4948Z",
    fill: "#ABAAD4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.278 49.6438C267.644 49.4673 265.886 58.7522 271.278 58.7522C276.669 58.7522 274.948 49.8215 271.278 49.6438Z",
    fill: "#ABAAD4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2559 112.515C66.2559 112.515 63.1071 109.967 60.2769 105.105C57.4467 100.244 56.2466 91.3776 56.2466 91.3776C56.2466 91.3776 57.5362 99.5816 61.5573 105.15C65.5785 110.719 66.6697 111.527 66.6697 111.527L66.2559 112.515Z",
    fill: "#4A7AFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M301.458 112.906C301.458 112.906 306.062 108.744 308.891 103.618C311.719 98.4916 312.698 94.1403 312.698 94.1403C312.698 94.1403 311.722 110.174 306.593 112.906C301.462 115.638 301.458 112.906 301.458 112.906Z",
    fill: "#4ABAFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M247.279 63.3824L246.912 63.5604C246.66 79.4284 246.482 88.4744 246.366 90.6994C246.481 90.6994 246.544 90.7624 246.544 90.8674C250.658 89.9024 252.904 89.4194 253.282 89.4194C253.523 88.9784 254.436 81.3384 256.011 66.4894C255.759 66.2374 252.852 65.2084 247.279 63.3824ZM253.44 92.8405C253.02 92.5675 252.485 92.3364 251.824 92.1474H251.457C247.815 92.7034 246 94.1625 246 96.5235V97.0694C246 98.7694 246.85 99.6194 248.561 99.6194H249.096C252.202 98.8634 253.976 97.5625 254.427 95.7155C254.437 95.6945 254.448 95.6844 254.448 95.6624C254.522 95.3584 254.553 95.0434 254.553 94.7074V94.6234C254.521 93.9004 254.153 93.3135 253.44 92.8405Z",
    fill: "url(#paint23_linear_336_2444)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M171.611 82.7834C175.629 79.9654 177.708 77.0024 177.862 73.8764C177.947 72.3524 177.739 70.9814 177.223 69.7654C174.375 65.2544 170.433 62.8374 165.391 62.5134L162.712 62.3824C154.344 63.0834 149.109 63.8064 147 64.5454L151.85 96.0394L152.32 99.1115L158.155 98.3105L163.536 97.5714L163.02 87.0244L171.611 82.7834ZM162.042 76.7094L161.634 72.7984C163.605 72.5594 165.252 72.5054 166.576 72.6444C167.7 72.8524 168.247 73.3754 168.193 74.2144C168.123 75.5544 166.075 76.3864 162.042 76.7094Z",
    fill: "url(#paint24_linear_336_2444)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171.611 82.7834C166.684 76.4014 172.334 83.4144 171.611 82.7834C175.629 79.9654 177.708 77.0024 177.862 73.8764C177.947 72.3524 177.739 70.9814 177.223 69.7654C174.375 65.2544 170.433 62.8374 165.391 62.5134L162.712 62.3824C154.344 63.0834 149.109 63.8064 147 64.5454L151.85 96.0394C153.944 96.7704 156.038 97.5255 158.155 98.3105L163.536 97.5714L163.02 87.0244L171.611 82.7834ZM162.042 76.7094L161.634 72.7984C163.605 72.5594 165.252 72.5054 166.576 72.6444C167.7 72.8524 168.247 73.3754 168.193 74.2144C168.123 75.5544 166.075 76.3864 162.042 76.7094Z",
    fill: "#DFE300"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M203.611 82.7834C207.629 79.9654 209.708 77.0024 209.862 73.8764C209.947 72.3524 209.739 70.9814 209.223 69.7654C206.375 65.2544 202.433 62.8374 197.391 62.5134L194.712 62.3824C186.344 63.0834 181.109 63.8064 179 64.5454L183.85 96.0394L184.32 99.1115L190.155 98.3105L195.536 97.5714L195.02 87.0244L203.611 82.7834ZM194.042 76.7094L193.634 72.7984C195.605 72.5594 197.252 72.5054 198.576 72.6444C199.7 72.8524 200.247 73.3754 200.193 74.2144C200.123 75.5544 198.075 76.3864 194.042 76.7094Z",
    fill: "url(#paint25_linear_336_2444)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.611 82.7834C198.684 76.4014 204.334 83.4144 203.611 82.7834C207.629 79.9654 209.708 77.0024 209.862 73.8764C209.947 72.3524 209.739 70.9814 209.223 69.7654C206.375 65.2544 202.433 62.8374 197.391 62.5134L194.712 62.3824C186.344 63.0834 181.109 63.8064 179 64.5454L183.85 96.0394C185.944 96.7704 188.038 97.5255 190.155 98.3105L195.536 97.5714L195.02 87.0244L203.611 82.7834ZM194.042 76.7094L193.634 72.7984C195.605 72.5594 197.252 72.5054 198.576 72.6444C199.7 72.8524 200.247 73.3754 200.193 74.2144C200.123 75.5544 198.075 76.3864 194.042 76.7094Z",
    fill: "#DFE300"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M144.379 70.4584C141.985 65.2084 137.766 62.5134 131.731 62.3824C129.876 62.3824 127.913 62.7135 125.834 63.3835C117.982 66.6395 113.701 72.9144 113.001 82.2134C112.993 83.4454 113.055 84.6154 113.186 85.7234C113.317 86.9165 113.532 88.0334 113.825 89.0794C115.68 95.3384 119.691 98.7174 125.865 99.2104C127.89 99.2104 129.768 98.9714 131.516 98.4714C134.349 97.6934 136.82 96.2625 138.929 94.1985C139.222 93.8365 139.499 93.4744 139.768 93.1134C140.245 92.4664 140.692 91.8124 141.108 91.1584C143.872 86.8014 145.257 82.2284 145.257 77.4244C145.38 74.8924 145.087 72.5674 144.379 70.4584ZM127.82 88.1024C125.141 88.1024 123.617 86.4314 123.24 83.0834C123.14 81.6594 123.348 80.2125 123.887 78.7415C126.266 74.3685 128.96 72.1824 131.963 72.1824C134.858 72.1824 136.305 73.8535 136.305 77.1945C136.413 79.4425 136.051 81.3284 135.227 82.8524C132.74 86.3554 130.268 88.1024 127.82 88.1024Z",
    fill: "url(#paint26_linear_336_2444)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.379 70.4584C141.985 65.2084 137.766 62.5134 131.731 62.3824C129.876 62.3824 127.913 62.7135 125.834 63.3835C117.982 66.6395 113.701 72.9144 113.001 82.2134C112.993 83.4454 113.055 84.6154 113.186 85.7234C121.777 87.7554 130.661 90.1964 139.768 93.1134C143.425 88.1784 145.257 82.9514 145.257 77.4244C145.38 74.8924 145.087 72.5674 144.379 70.4584ZM135.226 82.8524C132.739 86.3554 130.268 88.1024 127.82 88.1024C125.141 88.1024 123.617 86.4314 123.24 83.0834C123.14 81.6594 123.348 80.2125 123.887 78.7415C126.266 74.3685 128.96 72.1824 131.963 72.1824C134.858 72.1824 136.305 73.8535 136.305 77.1945C136.412 79.4425 136.05 81.3284 135.226 82.8524Z",
    fill: "#DFE300"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M238.109 66.2361L234.595 72.8423C229.775 69.319 224.889 69.5392 223.048 70.0897C221.877 70.4567 219.835 71.7413 221.04 73.9434C222.546 76.696 230.076 76.696 231.582 77.2465C233.088 77.797 244.133 83.3022 236.101 93.7621C229.675 102.13 216.689 97.2487 211 93.7621L215.016 87.1559C216.221 88.0367 218.865 89.3579 220.036 89.9085C221.71 90.459 225.759 91.2297 228.57 89.9085C231.382 88.5872 230.746 86.7888 230.076 86.0548C227.064 84.9538 226.544 84.2175 223.55 83.8527C219.032 83.3022 215.518 80.7331 213.51 78.8981C211.502 75.0444 212.506 71.1908 213.51 68.9883C217.024 63.4831 219.534 62.3828 225.558 62.3824C230.841 62.3821 236.101 64.5845 238.109 66.2361Z",
    fill: "#DBDC7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_2444",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.038 211.473) rotate(-14.1585) scale(46.1986 46.1986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_2444",
    x1: 119.399,
    y1: 218.73,
    x2: 133.06,
    y2: 215.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_2444",
    x1: 112.236,
    y1: 235.692,
    x2: 97.0533,
    y2: 246.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_2444",
    x1: 97.9753,
    y1: 232.551,
    x2: 83.6494,
    y2: 221.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_2444",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.265 215.86) rotate(-14.1585) scale(21.8287 21.8287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E8736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_2444",
    x1: 177.337,
    y1: 71.1537,
    x2: 181.134,
    y2: 156.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    stopColor: "#144533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#39721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8146,
    stopColor: "#508E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59980D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_2444",
    x1: 192.225,
    y1: 81.8954,
    x2: 195.403,
    y2: 153.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    stopColor: "#144533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#39721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8146,
    stopColor: "#508E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59980D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_2444",
    x1: -19.896,
    y1: 18.0516,
    x2: 83.9579,
    y2: 105.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_2444",
    x1: 17.7614,
    y1: 10.1723,
    x2: 51.9093,
    y2: 82.0627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_2444",
    x1: 1.71099,
    y1: 45.2623,
    x2: 38.2553,
    y2: 107.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_2444",
    x1: -1.35663,
    y1: 81.7882,
    x2: 70.5337,
    y2: 119.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_2444",
    x1: 52.0985,
    y1: 66.5033,
    x2: 13.3574,
    y2: 33.3537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_336_2444",
    x1: 34.781,
    y1: 88.3431,
    x2: 1.43159,
    y2: 69.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_336_2444",
    x1: 68.2394,
    y1: 111.168,
    x2: 2.14025,
    y2: 99.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_336_2444",
    x1: 390.895,
    y1: 18.0514,
    x2: 287.041,
    y2: 105.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_336_2444",
    x1: 352.703,
    y1: 12.2438,
    x2: 322.549,
    y2: 70.3554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_336_2444",
    x1: 369.289,
    y1: 48.7582,
    x2: 339.534,
    y2: 92.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_336_2444",
    x1: 370.31,
    y1: 80.6892,
    x2: 295.025,
    y2: 124.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_336_2444",
    x1: 320.779,
    y1: 68.7839,
    x2: 356.924,
    y2: 32.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_336_2444",
    x1: 333.421,
    y1: 93.4997,
    x2: 370.964,
    y2: 65.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_336_2444",
    x1: 297.729,
    y1: 111.724,
    x2: 366.025,
    y2: 100.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_336_2444",
    x1: 184.773,
    y1: 133.627,
    x2: 184.773,
    y2: 52.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_336_2444",
    x1: 55.6589,
    y1: 90.3044,
    x2: 313.886,
    y2: 90.3044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_336_2444",
    x1: 251.005,
    y1: 111.27,
    x2: 251.005,
    y2: 49.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#EACEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7432,
    stopColor: "#F7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_336_2444",
    x1: 163.539,
    y1: 100.561,
    x2: 163.539,
    y2: 43.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_336_2444",
    x1: 195.539,
    y1: 100.561,
    x2: 195.539,
    y2: 43.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_336_2444",
    x1: 129.142,
    y1: 100.661,
    x2: 129.142,
    y2: 43.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVictoryOneStar);
export default __webpack_public_path__ + "static/media/victoryOneStar.693630c8e53b226929c497afc61e60ae.svg";
export { ForwardRef as ReactComponent };